import { useRef } from 'react'

import type { HardwareSupplierFilterKeyType } from '../type'

/**
 * AbortSignal for shop home catalog fetches. When the user switches supplier (or
 * clears supplier), the previous signal is aborted so in-flight componentsv2
 * list requests are cancelled at the fetch layer.
 *
 * In-flight fetches are also aborted from each list effect's cleanup (Strict Mode
 * remount, navigation). We do not abort on unmount here: that duplicated work
 * with per-row cleanups and could fire after a fast 200 in odd timings.
 */
export function useShopHardwareListAbortSignal(distributor: HardwareSupplierFilterKeyType | undefined): AbortSignal {
  const distributorKeyRef = useRef(distributor)
  const controllerRef = useRef(new AbortController())

  if (distributorKeyRef.current !== distributor) {
    distributorKeyRef.current = distributor
    controllerRef.current.abort()
    controllerRef.current = new AbortController()
  }

  return controllerRef.current.signal
}
